export default __webpack_public_path__ + "static/media/Waste-elec-2-1point51-768x515.e7a00f70.jpg";